<template>
	<div class="detail">
		<div class="header">
			<div class="left" @click="goBack()">&lt;返回</div>
			<div class="span1">
				<span>作业反馈详情</span>
			</div>
			<div class="right"></div>
		</div>
		<div class="main" v-loading="loading">
			<div class="main-title">
				<img src="./img/hw-msg.png" alt="" />
				<p>作业信息</p>
			</div>
			<div class="main-li">
				<p>作业日期</p>
				<span>{{ detail.homeworkDate }}</span>
			</div>
			<div class="main-li">
				<p>作业标题</p>
				<span>{{ detail.title }}</span>
			</div>
			<div class="main-li">
				<p>作业截止时间</p>
				<span>{{ detail.deadline }}</span>
			</div>
			<div class="main-li">
				<p>预计完成时长</p>
				<span>{{ detail.estimateDuration }}分钟</span>
			</div>
			<div class="main-li">
				<p>作业内容</p>
				<span>{{ detail.content }}</span>
			</div>
			<div v-show="!viewMoreFlag">
				<div class="main-li">
					<p>附件</p>
					<ul class="file-detail" v-if="detail.resources && detail.resources.length">
						<li
							v-for="(item, i) in detail.resources"
							:key="i + '作业附件'"
							class="file-item"
							@click="previewUrl(item)"
						>
							<div>
								<img :src="ShowImg(item.ext)" class="img-icon" />
								<span>{{ item.name }}</span>
							</div>
						</li>
					</ul>
					<span v-else>暂无附件</span>
				</div>
				<div class="main-li">
					<p>设计意图</p>
					<span v-if="detail.purpose">{{ detail.purpose }}</span>
					<span v-else>暂无内容</span>
				</div>
				<div class="main-li">
					<p>发布班级</p>
					<span>{{ detail.classname }}</span>
				</div>
				<div class="main-li">
					<p>发布人</p>
					<span>{{ detail.createName }}</span>
				</div>
				<div class="main-li">
					<p>发布时间</p>
					<span>{{ detail.createTime }}</span>
				</div>
			</div>
			<div class="view-more-btn flex-center" @click="viewMore()">
				<span v-show="viewMoreFlag">
					查看更多 <span><img src="./img/view-more.png"/></span
				></span>
				<span v-show="!viewMoreFlag"
					>收起<span><img src="./img/pack-up.png"/></span
				></span>
			</div>
			<div class="main-title" style="margin-top:30px">
				<img src="./img/hw-detail.png" alt="" />
				<p>反馈详情</p>
			</div>
			<div class="main-li">
				<p>作业完成时长</p>
				<span>{{ detail.finishDuration }}分钟</span>
			</div>
			<div class="main-li">
				<p>作业难易程度</p>
				<span v-if="detail.difficulty == 1">容易</span>
				<span v-if="detail.difficulty == 2">较易</span>
				<span v-if="detail.difficulty == 3">一般</span>
				<span v-if="detail.difficulty == 4">较难</span>
				<span v-if="detail.difficulty == 5">困难</span>
			</div>
			<div class="main-li">
				<p>作业完成情况</p>
				<span v-if="detail.complete == 1">完成</span>
				<span v-if="detail.complete == 0">未完成</span>
			</div>
			<div class="main-li">
				<p>作业反馈意见</p>
				<span v-if="detail.suggestion">{{ detail.suggestion }}</span>
				<span v-else>暂无反馈意见</span>
			</div>
			<div class="main-li">
				<p>反馈人</p>
				<span>{{ detail.username }}</span>
			</div>
			<div class="main-li">
				<p>学生班级</p>
				<span>{{ detail.classname }}</span>
			</div>
			<div class="main-li">
				<p>反馈时间</p>
				<span>{{ detail.feedbackTime }}</span>
			</div>
		</div>
		<!-- 预览弹框 -->
		<el-dialog
			:visible.sync="dialogVisible"
			custom-class="preview-dialog center"
			:append-to-body="true"
		>
			<img class="close-image" @click="dialogVisible = false" src="./img/close-image.png" />
			<img v-if="fileType == 'image'" class=" preview-img center" :src="fileMsg.previewUrl" />
			<video
				v-else-if="fileType == 'video'"
				controls
				preload="metadata"
				class="preview-img center"
				:src="fileMsg.previewUrl"
			></video>
			<audio
				style="width:80%"
				v-else-if="fileType == 'audio'"
				controls
				preload="metadata"
				class="preview-img center"
				:src="fileMsg.previewUrl"
			></audio>
		</el-dialog>
	</div>
</template>
<script>
	import { getHwFeedbackDetail } from "@/api/school/index.js";
	import dayjs from "dayjs";

	export default {
		components: {},
		data() {
			return {
				loading: true,
				detail: {},
				feedbackDetail: {},
				showCheckArea: false, // 是否显示审核区域
				viewMoreFlag: true,
				dialogVisible: false, //弹框是否显示
				fileType: "", //文件类型
				fileMsg: {}, //点击的文件参数集合
			};
		},
		computed: {},
		created() {},
		activated() {
			console.log("activated");
			let query = this.$route.query;
			console.log("query--", query);
			let { homeworkId, userId } = query;
			this.getHwFeedbackInfo(homeworkId, userId);
		},
		deactivated() {
			this.$destroy();
		},
		mounted() {},
		methods: {
			viewMore() {
				this.viewMoreFlag = !this.viewMoreFlag;
			},
			goBack() {
				this.$router.go(-1);
			},
			// 预览附件
			previewUrl(item) {
				this.fileMsg = item;
				// console.log("item---", item);
				this.fileType = this.UseFileType(
					this.uploadType,
					this.UseFileType(this.suffixType, item.ext),
				);
				// console.log("this.fileType--", this.fileType);
				if (this.fileType === "image" || this.fileType === "video" || this.fileType === "audio") {
					this.dialogVisible = true;
				} else {
					window.open(item.previewUrl);
				}
			},
			// 查询作业反馈详情
			async getHwFeedbackInfo(homeworkId, userId) {
				this.loading = true;
				let params = {
					homeworkId: homeworkId,
					userId: userId,
				};
				const res = await getHwFeedbackDetail(params);
				this.loading = false;
				console.log("查作业反馈详情--", res);
				res.createTime = dayjs(res.createTime).format("YYYY-MM-DD HH:mm");
				res.deadline = dayjs(res.deadline).format("YYYY-MM-DD HH:mm");
				res.homeworkDate = dayjs(res.homeworkDate).format("YYYY-MM-DD HH:mm");
				res.feedbackTime = dayjs(res.feedbackTime).format("YYYY-MM-DD HH:mm");
				this.loading = false;
				if (!res) return;
				this.detail = res;
			},
			reject() {},
			pass() {},
		},
	};
</script>
<style lang="less" scoped>
	.detail {
		width: 100%;
		padding: 0px 30px 30px 30px;
		.header {
			height: 60px;
			line-height: 48px;
			margin-bottom: 20px;
			display: flex;
			justify-content: space-between;
			border-bottom: 1px solid #eee;
			align-items: center;
			.span1 {
				font-family: "PingFang SC Bold";
				font-size: 20px;
				color: #000;
				margin-right: 30px;
			}
			.left,
			.right {
				width: 60px;
			}
			.left {
				font-size: 14px;
				color: #8b8b8b;
				cursor: pointer;
			}
		}
		.main-title {
			display: flex;
			align-items: center;
			p {
				font-weight: bold;
				font-size: 14px;
				color: #181c26;
				margin-left: 10px;
			}
			img {
				width: 16px;
				height: 16px;
			}
		}
		.main {
			width: 100%;
			height: 100%;

			.main-li {
				margin-top: 20px;
				width: 100%;
				display: flex;
				// align-items: center;
				font-size: 14px;
				color: #888;
				p {
					width: 120px;
					text-align: right;
					margin-right: 20px;
				}
				span {
					width: calc(100% - 150px);
					word-wrap:break-word;
				}
			}
		}

		.file-detail {
			width: 100%;
			.file-item {
				width: 233px;
				height: 50px;
				line-height: 50px;
				border-radius: 4px;
				background: #f4f9ff;
				position: relative;
				display: inline-block;
				margin-right: 20px;
				margin-bottom: 10px;
				text-align: center;
				font-size: 14px;
				color: #333;
				cursor: pointer;
				div {
					display: flex;
					align-items: center;
					.img-icon {
						margin-left: 10px;
						width: 36px;
						height: 40px;
					}
					span {
						margin-left: 10px;
						width: 300px;
						text-align: left;
						// 省略号
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
				}
			}
		}

		.view-more-btn {
			padding-bottom: 30px;
			border-bottom: 1px solid #eee;
			color: #4991e1;
			font-size: 16px;
			cursor: pointer;

			img {
				width: 15px;
				height: 10px;
				vertical-align: middle;
				margin-left: 10px;
			}
		}

		.handle-header {
			display: flex;
			padding-left: 80px;
			margin-top: 20px;
			span {
				width: calc(60% + 53px);
			}
		}
		.handle-item {
			width: 100%;
			height: 50px;
			margin-top: 30px;
			font-size: 14px;
			display: flex;
			align-items: center;
			padding-left: 80px;
			position: relative;
			.line {
				position: absolute;
				width: 1px;
				height: calc(100% + 10px);
				background: #eeeeee;
				left: 90px;
				top: calc(50% + 10px);
			}
			.handle-mind {
				width: 60%;
				margin-left: 15px;
				display: flex;
				align-items: center;
				.handle-title {
					margin-left: 20px;
					.text {
						color: #999999;
						margin-top: 2px;
					}
				}
				.blue {
					color: #4991e1;
				}
			}
			.handle-time {
				margin-left: 20px;
				color: #999999;
			}
		}
		.handle-user {
			color: #666666;
			padding-left: 112px;
		}
	}
	footer {
		margin-top: 50px;
		display: flex;
		justify-content: center;
	}
	::v-deep .preview-dialog {
		width: 800px;
		height: 450px;
		margin-top: 0 !important;
		margin: 0;
		.preview-img {
			max-width: 100%;
			max-height: 100%;
			object-fit: contain;
			flex-grow: 0;
		}
		.close-image {
			position: absolute;
			top: -26px;
			right: -26px;
			width: 58px;
			height: 58px;
		}
	}
	::v-deep .el-dialog__header {
		padding: 0;
	}
	::v-deep .el-dialog__body {
		// position: relative;
		padding: 0;
		width: 100%;
		height: 100%;
	}
	::v-deep .el-dialog__headerbtn .el-dialog__close {
		display: none;
	}
</style>
